module.exports = __webpack_public_path__ + "inscricao/static/media/img-card.2997c568.png";